export default __webpack_public_path__ + "static/malwinapk-eb1daa2c583acd6e0988a76387d7f5fa.webp";